@use './variables' as *;

:host {
  display: $badge-host-display;
}

.badge {
  display: $badge-display;
  padding-top: $badge-padding-top;
  padding-right: $badge-padding-right;
  padding-bottom: $badge-padding-bottom;
  padding-left: $badge-padding-left;
  border-radius: $badge-border-radius;
  background-color: $badge-background-color;

  &-text {
    font-size: $badge-font-size;
    font-family: $badge-font-family;
    font-weight: $badge-font-weight;
    line-height: $badge-line-height;
    color: $badge-color;
  }
}
